import React from "react"
import { Chip as PrimeChip } from "primereact/chip"
/**
 * @type {React.ForwardRefRenderFunction<
 *   import('primereact/chip').Chip,
 *   import('primereact/chip').ChipProps
 * >}
 */
const Chip = React.forwardRef((props, ref) => {
  return <PrimeChip {...props} ref={ref} />
})

export default Chip
